// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"styles_statusIcon__aBjDK","iconContainer":"styles_iconContainer__113dQ","icon":"styles_icon__1j0oz","statusLabel":"styles_statusLabel__2bUoV"};